import React from 'react';
import { Card, Space, Typography } from 'antd';
import { HolderOutlined } from '@ant-design/icons';
import { useChartView } from './ChartRenderer';

const CHART_CARD_BODY_STYLES = {
    height: 'calc(100% - 40px)',
    overflow: 'hidden',
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
};

/**
 * Chart card with view controls (chart / table / export) in the header extra (top right).
 */
const { Text } = Typography;

export default function ReportingChartCard({
    title,
    description,
    extra,
    chartProps,
    className,
    dragHandleClassName,
}) {
    const { toolbar, body, expandModal } = useChartView(chartProps);

    return (
        <>
        <Card
            size="small"
            className={className}
            style={{ height: '100%' }}
            styles={{ body: CHART_CARD_BODY_STYLES }}
            title={(
                <Space size={8} align="start">
                    {dragHandleClassName ? (
                        <span
                            className={dragHandleClassName}
                            style={{
                                cursor: 'grab',
                                userSelect: 'none',
                                lineHeight: 1,
                                display: 'inline-flex',
                                alignItems: 'center',
                                padding: '2px 4px',
                            }}
                            aria-label="Drag chart"
                        >
                            <HolderOutlined />
                        </span>
                    ) : null}
                    <span className="no-drag">
                        <ChartCardTitle title={title} description={description} />
                    </span>
                </Space>
            )}
            extra={(
                <Space size={8} className="no-drag" onClick={e => e.stopPropagation()}>
                    {extra}
                    {toolbar}
                </Space>
            )}
        >
            <div className="no-drag" style={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
                {body}
            </div>
        </Card>
        {expandModal}
        </>
    );
}

function ChartCardTitle({ title, description }) {
    if (!description?.trim()) return title;
    return (
        <div>
            <div>{title}</div>
            <Text type="secondary" style={{ fontSize: 11, fontWeight: 400, display: 'block', marginTop: 2 }}>
                {description}
            </Text>
        </div>
    );
}
